// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"59fe5ade","644":"6781b19e"}[chunkId] + ".chunk.js";
};